import * as yup from 'yup';

import {
  ERROR_MESSAGE_REQUIRED_ZIP_CODE,
  emailValidationSchema,
  phoneNumberValidationSchema,
  zipCodeValidationSchema,
} from 'src/constants/validation';
import { WEBSITE_REG_EXP } from 'src/constants/validationWebsite';

import {
  CommercialVerifierCompanyInformationFormFields,
  CompanyInformationFormAddressFields,
  GovernmentVerifierCompanyInformationFormFields,
} from '../types';

export const CommercialVerifierCompanyInformationFormValidationSchema = yup.object({
  [CommercialVerifierCompanyInformationFormFields.displayName]: yup
    .string()
    .nullable()
    .required('Required company display name'),
  [CommercialVerifierCompanyInformationFormFields.legalBusinessName]: yup
    .string()
    .nullable()
    .required('Required registered business name'),
  [CommercialVerifierCompanyInformationFormFields.commercialName]: yup
    .string()
    .nullable()
    .optional(),
  [CommercialVerifierCompanyInformationFormFields.fEIN]: yup
    .string()
    .nullable()
    .min(9, 'Must be 9 characters')
    .required('Required FEIN'),
  [CommercialVerifierCompanyInformationFormFields.industry]: yup.lazy(value => {
    switch (typeof value) {
      case 'object':
        return yup.object().nullable().required('Required industry');
      case 'string':
        return yup.string().nullable().required('Required industry');
      default:
        return yup.mixed();
    }
  }),
  [CommercialVerifierCompanyInformationFormFields.contactPhone]:
    phoneNumberValidationSchema.required('Required phone number'),
  [CommercialVerifierCompanyInformationFormFields.contactEmail]:
    emailValidationSchema.required('Required contact email'),
  [CommercialVerifierCompanyInformationFormFields.address]: yup.object({
    [CompanyInformationFormAddressFields.street]: yup.string().required('Required street'),
    [CompanyInformationFormAddressFields.city]: yup.string().required('Required city'),
    [CompanyInformationFormAddressFields.county]: yup.string().required('Required county'),
    [CompanyInformationFormAddressFields.state]: yup.string().required('Required state'),
    [CompanyInformationFormAddressFields.zipCode]: zipCodeValidationSchema.required(
      ERROR_MESSAGE_REQUIRED_ZIP_CODE,
    ),
  }),
  [CommercialVerifierCompanyInformationFormFields.websiteURL]: yup
    .string()
    .nullable()
    .matches(WEBSITE_REG_EXP, 'Must be a valid URL')
    .required(),
});

export const GovernmentVerifierCompanyInformationFormValidationSchema = yup.object({
  [GovernmentVerifierCompanyInformationFormFields.displayName]: yup
    .string()
    .nullable()
    .required('Required company display name'),
  [GovernmentVerifierCompanyInformationFormFields.governmentEntityName]: yup
    .string()
    .nullable()
    .required('Required government entity name'),
  [GovernmentVerifierCompanyInformationFormFields.department]: yup
    .string()
    .nullable()
    .required('Required department'),
  [GovernmentVerifierCompanyInformationFormFields.commercialName]: yup
    .string()
    .nullable()
    .optional(),
  [GovernmentVerifierCompanyInformationFormFields.fEIN]: yup
    .string()
    .nullable()
    .min(9, 'Must be 9 characters')
    .required('Required FEIN'),
  [GovernmentVerifierCompanyInformationFormFields.typeOfGovernment]: yup
    .string()
    .nullable()
    .required('Required type of government'),
  [GovernmentVerifierCompanyInformationFormFields.industry]: yup.lazy(value => {
    switch (typeof value) {
      case 'object':
        return yup.object().nullable().required('Required industry');
      case 'string':
        return yup.string().nullable().required('Required industry');
      default:
        return yup.mixed();
    }
  }),
  [GovernmentVerifierCompanyInformationFormFields.contactPhone]:
    phoneNumberValidationSchema.required('Required phone number'),
  [GovernmentVerifierCompanyInformationFormFields.contactEmail]:
    emailValidationSchema.required('Required contact email'),
  [GovernmentVerifierCompanyInformationFormFields.address]: yup.object({
    [CompanyInformationFormAddressFields.street]: yup.string().required('Required street'),
    [CompanyInformationFormAddressFields.city]: yup.string().required('Required city'),
    [CompanyInformationFormAddressFields.county]: yup.string().required('Required county'),
    [CompanyInformationFormAddressFields.state]: yup.string().required('Required state'),
    [CompanyInformationFormAddressFields.zipCode]: zipCodeValidationSchema.required(
      ERROR_MESSAGE_REQUIRED_ZIP_CODE,
    ),
  }),
  [GovernmentVerifierCompanyInformationFormFields.websiteURL]: yup
    .string()
    .nullable()
    .matches(WEBSITE_REG_EXP, 'Must be a valid URL')
    .required(),
});
